import { Stack } from 'ui/stack';
import { Box } from 'ui/box';

import { Chip } from 'components/partials/insight-modal/shared/components';
import BlockHeader from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/components/block-header';

export interface ContextMetadata {
  insightType?: string;
  source?: string;
  sourceId?: string | number;
  relatedGoals?: string[];
  reportFilters?: Array<string | { column: string; values: string | string[] }>;
  [key: string]: unknown;
}

interface MonitoringContextProps {
  metadata: ContextMetadata | undefined;
}

const MonitoringContext = ({
  metadata,
}: MonitoringContextProps): React.JSX.Element => (
  <Stack sx={{ gap: 2 }}>
    <Box>
      <BlockHeader title="Critical Element" />
      <Chip>{metadata?.source || 'N/A'}</Chip>
    </Box>

    {metadata?.relatedGoals && !!metadata.relatedGoals.length && (
      <Box>
        <BlockHeader title="Related goals" />
        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
          {metadata.relatedGoals.map((goal, index) => (
            <Chip key={index}>{goal}</Chip>
          ))}
        </Stack>
      </Box>
    )}
  </Stack>
);

export default MonitoringContext;
